import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum ToggleWidgetSource {
    TOOLBAR = "TOOLBAR",
    WIDGET = "WIDGET",
}

enum WidgetEventNames {
    TOGGLE_WIDGET = "toggle_widget_event",
    RESET_WIDGETS = "reset_widgets_event",
}

export class ToggleWidgetEvent extends AmplitudeEvent {
    static SOURCES = ToggleWidgetSource;
    /* Records a widget's display being toggled */
    constructor(source: ToggleWidgetSource, isOpen: boolean, widget: string) {
        super(WidgetEventNames.TOGGLE_WIDGET);
        this.props = { source, isOpen, widget };
    }
}

export class ResetWidgetsEvent extends AmplitudeEvent {
    /* Records a reset action triggered from widget toolbar */
    constructor(source: ToggleWidgetSource) {
        super(WidgetEventNames.RESET_WIDGETS);
        this.props = { source };
    }
}
